export default __webpack_public_path__ + "static/media/Alka Sharma.3c487076.png";